import { render, staticRenderFns } from "./AppConfiguration.vue?vue&type=template&id=f38ee660&scoped=true"
import script from "./AppConfiguration.vue?vue&type=script&lang=js"
export * from "./AppConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AppConfiguration.vue?vue&type=style&index=0&id=f38ee660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ee660",
  null
  
)

export default component.exports